import gql from "graphql-tag";
import { ProductProps } from "../types/productTypes";
import { PageInfo, ProductTaxonomyFilterInput } from "../types/generalTypes";

export interface ProductsOrderbyInput {
  field: string;
  order?: string;
}

export interface GetProductsVariables {
  limit: number;
  before?: string;
  after?: string;
  category?: string;
  orderby?: ProductsOrderbyInput[];
  taxonomyFilter?: ProductTaxonomyFilterInput[];
  minPrice?: number;
  maxPrice?: number;
  onSale?: boolean;
  day?: number;
  month?: number;
  year?: number;
  ids?: number[];
  brandFilter?: ProductTaxonomyFilterInput[];
  categoryIn?: number[];
}

export interface GetProductsResponse {
  products: {
    nodes: ProductProps[];
    pageInfo?: PageInfo;
  };
}

export const getProducts = gql`
  query getProducts(
    $last: Int
    $limit: Int
    $after: String
    $before: String
    $category: String
    $orderby: [ProductsOrderbyInput]
    $taxonomyFilter: [ProductTaxonomyFilterInput]
    $minPrice: Float
    $maxPrice: Float
    $onSale: Boolean
    $day: Int
    $month: Int
    $year: Int
    $ids: [Int]
    $brandFilter: [ProductTaxonomyFilterInput]
    $categoryIn: [Int]
  ) {
    products(
      last: $last
      first: $limit
      after: $after
      before: $before
      where: {
        category: $category
        categoryIdIn: $categoryIn
        orderby: $orderby
        taxonomyFilter: { and: $brandFilter, or: $taxonomyFilter }
        minPrice: $minPrice
        maxPrice: $maxPrice
        onSale: $onSale
        dateQuery: { after: { day: $day, month: $month, year: $year } }
        include: $ids
        stockStatus: IN_STOCK
      }
    ) {
      nodes {
        id
        slug
        databaseId
        name
        type

        ... on VariableProduct {
          id
          name
          regularPrice
          salePrice
          onSale
          variations(first: 20, where: { stockStatus: IN_STOCK }) {
            nodes {
              id
              stockQuantity
            }
          }
        }
        ... on SimpleProduct {
          id
          name
          stockStatus
          stockQuantity
          regularPrice
          salePrice
          onSale
        }
        image {
          id
          slug
          mediaItemUrl
          sourceUrl(size: _630X500)
        }
        productCategories {
          nodes {
            id
            slug
            name
            databaseId
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;
